module.exports = __webpack_public_path__ + "img/notary-journal_B09JR9TH5T.8c87e37c.jpg";